export default {"src":"/_next/static/media/chef.59355387.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};